var WebOsVideo = require('./WebOsVideo');

module.exports = WebOsVideo;
